const ID_TOKEN_KEY = "id_token" as string;
const ID_REFRESH_TOKEN_KEY = "refresh_token" as string;
const ID_USER_KEY = "user" as string;

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

/**
 * @description get refresh token form localStorage
 */
export const getRefreshToken = (): string | null => {
  return window.localStorage.getItem(ID_REFRESH_TOKEN_KEY);
};

/**
 * @description get refresh token form localStorage
 */
export const getUser = (): string | null => {
  return window.localStorage.getItem(ID_USER_KEY);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string, refreshToken: string, user): void => {
  // TODO: Guardar el token en httpOnly cookie por seguridad
  window.localStorage.setItem(ID_TOKEN_KEY, token);
  window.localStorage.setItem(ID_REFRESH_TOKEN_KEY, refreshToken);
  window.localStorage.setItem(ID_USER_KEY, JSON.stringify(user));
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export default { getToken, getUser, getRefreshToken, saveToken, destroyToken };
